import { render } from "./ui-multiselect.vue?vue&type=template&id=645273f1&scoped=true&ts=true"
import script from "./ui-multiselect.vue?vue&type=script&lang=ts"
export * from "./ui-multiselect.vue?vue&type=script&lang=ts"

import "./ui-multiselect.vue?vue&type=style&index=0&id=645273f1&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645273f1"]])

export default __exports__